module.exports = __webpack_public_path__ + "img/helpful-hanukkah.a8be8cce.png";